var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlayButton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 143,
    height: 70,
    viewBox: "0 0 143 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5354_12112)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128.348 8.0293L137.491 17.0859V52.8125L128.348 61.8701H15.7061L6.55469 52.8125V17.0859L15.7061 8.0293H128.348Z",
    fill: "#000053",
    stroke: "#FF4D07",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.15723 10.4511L13.2354 1.4585H131.025L140.103 10.3044",
    stroke: "#00BFFF",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.345 59.587L131.267 68.5796L13.4767 68.5796L4.39855 59.7336",
    stroke: "#00BFFF",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0286 39.7681H29.9583V34.4751H37.0286C37.9922 34.4751 38.7734 34.3123 39.3724 33.9868C39.9714 33.6613 40.4076 33.2121 40.681 32.6392C40.9675 32.0532 41.1107 31.3957 41.1107 30.6665C41.1107 29.8853 40.9675 29.1626 40.681 28.4985C40.4076 27.8345 39.9714 27.3006 39.3724 26.897C38.7734 26.4803 37.9922 26.272 37.0286 26.272H32.5365V49.4165H25.681V20.979H37.0286C39.3073 20.979 41.2669 21.3957 42.9076 22.229C44.5612 23.0623 45.8307 24.2082 46.7161 25.6665C47.6016 27.1118 48.0443 28.7655 48.0443 30.6274C48.0443 32.4634 47.6016 34.0649 46.7161 35.4321C45.8307 36.7993 44.5612 37.867 42.9076 38.6353C41.2669 39.3905 39.3073 39.7681 37.0286 39.7681ZM70.5247 44.1431V49.4165H56.1497V44.1431H70.5247ZM58.5911 20.979V49.4165H51.7357V20.979H58.5911ZM85.8568 26.9556L78.9232 49.4165H71.5599L82.0091 20.979H86.6771L85.8568 26.9556ZM91.599 49.4165L84.6458 26.9556L83.7474 20.979H88.474L98.9818 49.4165H91.599ZM91.3255 38.811V44.104H76.7357V38.811H91.3255ZM103.298 20.979L108.533 33.3228L113.786 20.979H121.169L112.029 39.2017V49.4165H105.056V39.2017L95.8958 20.979H103.298Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5354_12112"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 143,
    height: 70,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayButton);
export default __webpack_public_path__ + "static/media/play_button.e7043805.svg";
export { ForwardRef as ReactComponent };